import { useTranslation } from 'react-i18next';

import { CustomModal, CustomModalProps } from 'components/shared';

import styles from './SendPalletsWithWrongAddressesWarningModal.module.css';

type SendPalletsWithWrongAddressesWarningModalProps = Pick<CustomModalProps, 'opened'> & {
   onConfirm: () => void;
   onCancel: () => void;
};

const SendPalletsWithWrongAddressesWarningModal = ({
   opened,
   onConfirm,
   onCancel,
}: SendPalletsWithWrongAddressesWarningModalProps) => {
   const { t } = useTranslation();

   return (
      <CustomModal
         opened={opened}
         onClose={onCancel}
         icon="ALERT_TRIANGLE"
         innerTitle={t('sendPalletsModal.sendPalletsWithWrongAddressesWarningModal.title')}
         modalContentClassName={styles.modalContent}
         secondaryButtonProps={{
            text: t('cancel_pallet_report_modal.back'),
            variant: 'outlined-danger',
            onClick: onCancel,
         }}
         primaryButtonProps={{
            text: t('sendPallets.sendPalletsBtn'),
            variant: 'filled-danger',
            onClick: onConfirm,
         }}
      >
         <p>{t('sendPalletsModal.sendPalletsWithWrongAddressesWarningModal.description')}</p>
      </CustomModal>
   );
};

export default SendPalletsWithWrongAddressesWarningModal;
